import script from "./SalesRebateSchemaDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./SalesRebateSchemaDetail.vue?vue&type=script&setup=true&lang=ts"

import "./SalesRebateSchemaDetail.vue?vue&type=style&index=0&id=7577aa2f&lang=css"

const __exports__ = script;

export default __exports__